import DashboardSection from "./DashboardSection";

import "./StatusChart.css";

const STATUS_LABELS = {
  active: "Actief",
  paused: "Gepauzeerd",
  completed: "Afgerond",
  archived: "Gearchiveerd",
};

export default function StatusChart({ items = [] }) {
  const total = items.reduce((sum, item) => sum + Number(item.count || 0), 0);

  return (
    <DashboardSection
      title="Status overzicht"
      description="Verdeling per status."
    >
      <div className="status-chart">
        {items.length === 0 ? (
          <div className="status-chart__empty">Geen statusgegevens.</div>
        ) : (
          items.map((item) => {
            const percentage =
              total > 0 ? Math.round((item.count / total) * 100) : 0;

            return (
              <div key={item.status} className="status-chart__row">
                <div className="status-chart__label">
                  <strong>{STATUS_LABELS[item.status] || item.status}</strong>
                  <span>
                    {item.count} · {percentage}%
                  </span>
                </div>

                <div className="status-chart__bar">
                  <div style={{ width: `${percentage}%` }} />
                </div>
              </div>
            );
          })
        )}
      </div>
    </DashboardSection>
  );
}
